import React from 'react';
import { useSelector } from 'react-redux';
import { getProductQuantity } from '@yme/pdp-components/ProductCard';
import { getRTL } from '@yme/selectors/index';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { formatPrice } from '@yme/utils/formatPrice';
import { AllProductUnitPricesStyled, StrikethroughTextStyled } from './styled';
export function AllProductUnitPrices({ products, rootLanguage, }) {
    const isRightToLeft = useSelector(getRTL);
    const productQuantity = useSelector(getProductQuantity);
    return (React.createElement(AllProductUnitPricesStyled, { isRightToLeft: isRightToLeft },
        React.createElement(FlexWrapper, { flexDirection: "column", gap: "8px", alignItems: "flex-start", isFullWidth: true }, products.length &&
            products.map((product, index) => {
                const price = product.price.discount?.discountedPrice ?? product.price.amount;
                const isDiscount = price && product.price.hasOwnProperty('discount');
                return (React.createElement(FlexWrapper, { isFullWidth: true, key: product.id, justifyContent: "space-between" },
                    React.createElement(RegularTextLevel3, null, product.name),
                    React.createElement(RegularTextLevel3, null,
                        isDiscount && (React.createElement(StrikethroughTextStyled, null, formatPrice({
                            locale: rootLanguage,
                            currencyName: product.price?.currencyCode,
                            price: index === 0
                                ? product.price.amount * productQuantity
                                : product.price.amount,
                        }))),
                        formatPrice({
                            locale: rootLanguage,
                            currencyName: product.price?.currencyCode,
                            price: index === 0 ? price * productQuantity : price,
                        }))));
            }))));
}
AllProductUnitPrices.displayName = 'AllProductUnitPrices_Component';
